import Analytics from '@web/services/Analytics/Analytics'

export function onboardingView (payload: {
  screenNumber: number
  screenName: string
}): void {
  Analytics.send({
    action: 'onboarding_view',
    screen_number: String(payload.screenNumber),
    screen_name: payload.screenName
  })
}

export function onboardingCompleted (payload: {
  url: string
  courseId?: number
}): void {
  const data: EventBase = {
    action: 'onboarding_completed',
    url: payload.url
  }
  if (payload.courseId !== undefined) {
    data.course_id = String(payload.courseId)
  }
  Analytics.send(data)
}

export function onboardingSelfieChoice (payload: {
  choice: 'allow_selfie' | 'skip_selfie'
}): void {
  Analytics.send({
    action: 'onboarding_selfie_choice',
    choice: payload.choice
  })
}

export function onboardingContinueClick (payload: {
  screenNumber: number
  screenName: string
}): void {
  Analytics.send({
    action: 'onboarding_continue_click',
    screen_number: String(payload.screenNumber),
    screen_name: payload.screenName
  })
}

export function onboardingCardCtaClick (payload: {
  screenNumber: number
  screenName: string
  cardName: string
  ctaName: string
}): void {
  Analytics.send({
    action: 'onboarding_card_cta_click',
    screen_number: String(payload.screenNumber),
    screen_name: payload.screenName,
    card_name: payload.cardName,
    cta_name: payload.ctaName
  })
}
